// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__34Iyp","loaderOuter":"PageOverlayLoader_loaderOuter__1C9DN"};